import React, { Component } from 'react';
import { Button, Grid } from 'semantic-ui-react';
import $ from 'jquery';
import config from '../../../config.json';
import { PtInput, PtDateInput } from '../../../grit-utilities';

const txtStyle = {
    fontSize: "15px",
    fontWeight: "bold",
    marginTop: "15px"
}

export default class DocumentsGallery extends Component {

    constructor(props) {

        super(props)
        const { documentsModel } = this.props;
        console.log(documentsModel)

        this.state =
        {
            galleryModel: documentsModel || [],
            selectedIndex: 0,
            nextBtndisable: false,
            prevBtndisable: true,
            uploadResponse: "",
            layer: this.props.constructionPlanning.layer,
            agencyId: this.props.constructionPlanning.agencyId,
            comment: documentsModel && documentsModel.length ? documentsModel[0].Comment : '',
            dateCreated: documentsModel && documentsModel.length && documentsModel[0].DateCreated ? documentsModel[0].DateCreated.slice(0, 10) : null
        }

    }

    componentDidUpdate() {
        // this.props.documentsModel = this.state.galleryModel;
    }

    setWebcamRef = element => {
        this.webcam = element;
    }

    setHiddenFileInputRef = element => {
        this.hiddenFileInput = element;
    }

    renameFile = (originalFile, newName) => {
        return new File([originalFile], newName, {
            type: originalFile.type,
            lastModified: originalFile.lastModified,
        });
    }

    uploadFileButtonClick = e => {
        document.getElementById('document_input').click();
    }

    handleFileChange = e => {
        const { name } = e.target
        this.setState({ [name]: e.target.files[0] });
        var data = new FormData();

        var time = Date.now();
        var month = new Date().getMonth()
        var date = new Date().getDate()
        var year = new Date().getFullYear()

        var planningValue = this.props.constructionPlanning;
        if (planningValue && planningValue.layerId && planningValue.layerId != -1 && planningValue.projectInfo && planningValue.projectInfo.townshipId) {
            for (const single_file of e.target.files) {
                if (single_file.type == "application/pdf") {
                    let renamed_file = this.renameFile(single_file,
                        planningValue.layerId + "_" + planningValue.layer + "_" + month + "_" + date + "_" + year + "_" + time + ".pdf");
                    time = Date.now();
                    data.append('selectedFile', renamed_file);
                } else {
                    alert("File type must be pdf. This file is not added: " + single_file.name);
                }
            }
        } else {
            alert('Please upload documents after saving the changes.');
        }

        e.target.value = null;
        // when done is false, there are entries
        let dataIsNotEmpty = !(data.entries().next().done);

        if (dataIsNotEmpty) {
            console.log(data)
            $.ajax({
                type: "POST",
                url: `${config.server}\\upload\\documents`,
                data: data,
                processData: false,
                contentType: false,
                success: (response) => {
                    if (response['message'] === "Uploaded") {
                        this.loadDocuments(this.state.galleryModel.length);
                        this.setState({ uploadResponse: response['message'] });
                        alert('Documents have been saved successfully!')
                    }
                },
                error: (error) => {
                    alert('Error: Failed to save documents')
                    console.log(error)
                }
            });
        } else {
            console.log("Zero valid files selected. Ensure to select only pdf files.");
        }

    }

    next = () => {
        if (this.state.selectedIndex === this.state.galleryModel.length - 1)
            this.setState({ nextBtndisable: true })
        else {
            let index = this.state.selectedIndex + 1;
            console.log("Index in next ", this.state.galleryModel[index])
            this.setState({
                selectedIndex: index, nextBtndisable: false, prevBtndisable: false,
                comment: this.state.galleryModel[index].Comment || '',
                dateCreated: this.state.galleryModel[index].DateCreated ? this.state.galleryModel[index].DateCreated.slice(0, 10) : null
            })
        }
    }

    previous = () => {
        if (this.state.selectedIndex === 0)
            this.setState({ prevBtndisable: true })
        else {
            let index = this.state.selectedIndex - 1;
            console.log("Index in prev ", this.state.galleryModel[index])
            this.setState({
                selectedIndex: index, prevBtndisable: false, nextBtndisable: false,
                comment: this.state.galleryModel[index].Comment || '',
                dateCreated: this.state.galleryModel[index].DateCreated ? this.state.galleryModel[index].DateCreated.slice(0, 10) : null
            })
        }
    }

    deleteDocument = () => {
        let finalData = {
            documentKey: this.state.galleryModel[this.state.selectedIndex].Id,
            filePath: this.state.galleryModel[this.state.selectedIndex].Full_Path,
            fileName: this.state.galleryModel[this.state.selectedIndex].File_Name
        };

        $.ajax({
            type: 'POST',
            url: `${config.server}\\deletedocument`,
            contentType: 'application/json',
            data: JSON.stringify(finalData),
            success: (data) => {
                this.loadDocuments(0);
                console.log('Success data ', data)
                alert('File deleted successfully!')
            },
            error: (error) => {
                alert('Error: Failed to delete file')
                console.log(error)
            }
        });
    }

    saveComment = () => {

        let finalData = {
            documentKey: this.state.galleryModel[this.state.selectedIndex].Id,
            comment: this.state.comment,
            dateCreated: this.state.dateCreated
        };
        console.log(finalData)
        $.ajax({
            type: 'POST',
            url: `${config.server}\\savedocumentuploadcomment`,
            contentType: 'application/json',
            data: JSON.stringify(finalData),

            success: (data) => {
                console.log('Success data ', data)
                if (data['message'] === "OK") {
                    this.loadDocuments(this.state.selectedIndex);
                    alert('Comments have been saved successfully!')
                }

            },
        });
    }

    loadDocuments(index = 0) {
        let constructionPlanningId = this.props.constructionPlanning.layerId;
        $.ajax({
            type: 'GET',
            url: `${config.server}\\documents\\${constructionPlanningId}`,
            contentType: 'application/json',
            success: (data) => {
                this.setState({
                    galleryModel: data.data || [],
                    nextBtndisable: false,
                    selectedIndex: index,
                    prevBtndisable: false,
                    comment: data.data && data.data.length && data.data.length > index ? data.data[index].Comment : '',
                    dateCreated: data.data && data.data.length && data.data.length > index && data.data[index].DateCreated ? data.data[index].DateCreated.slice(0, 10) : null
                });
            },
        });
    }

    onUpdateItems = (e) => {
        const { name, value } = e.target
        this.setState({ [name]: value })

    };

    onChangeDate = (date, name) => {
        if (date instanceof Date && !isNaN(date)) {
            this.setState({ [name]: `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}` });
        }
    }

    render() {
        const buttonText = "Upload PDF from Device";
        return (
            <div id="root">

                <form id="frmUploader" encType="multipart/form-data" action="/upload/documents" method="post">
                    <input id="document_input" name="selectedFile" type="file" onChange={this.handleFileChange} ref={this.setHiddenFileInputRef}
                        style={{ display: 'none' }} accepts="application/pdf" />
                </form>

                {/* {this.state.galleryModel.length > 0 && */}
                <object data={this.state.galleryModel.length > 0 ? this.state.galleryModel[this.state.selectedIndex].Full_Path : 'No PDF available'} type="application/pdf" width="330px" height="200px">
                    <p>Unable to display PDF file.
                        <a href={this.state.galleryModel.length > 0 ? this.state.galleryModel[this.state.selectedIndex].Full_Path : ''}>Download</a>
                        or
                        <a href={this.state.galleryModel.length > 0 ? this.state.galleryModel[this.state.selectedIndex].Full_Path : ''} target="_blank">View in Fullscreen</a>
                        instead.</p>
                </object>
                {/* } */}

                <div style={{ marginBottom: "20px", marginTop: "5px" }}>
                    <Button size='small' onClick={this.uploadFileButtonClick} color='green' style={{ marginTop: "10px" }} disabled={this.props.disabled}>{buttonText}</Button>
                    {this.state.galleryModel.length > 0 &&
                        <a className="ui green small button" style={{ backgroundColor: "teal" }} href={this.state.galleryModel[this.state.selectedIndex].Full_Path} target="_blank">
                            Download
                        </a>
                    }
                </div>

                {
                    this.state.galleryModel.length > 0 &&
                    <PtInput label="Comment" value={this.state.comment}
                        onChange={this.onUpdateItems} name="comment" disabled={this.props.disabled} />
                }

                {this.state.galleryModel.length > 0 &&
                    <PtDateInput label='Date Taken' placeholder="Not Available" minDate={new Date(1900, 0, 1)} maxDate={new Date(2050, 5, 5)}
                        inputType="hwy" name="dateCreated" disabled={this.props.disabled}
                        value={this.state.dateCreated}
                        onChange={(date) => this.onChangeDate(date, "dateCreated")} />}

                {this.state.galleryModel.length > 0 &&
                    <Button color="green" disabled={this.props.disabled} onClick={() => this.saveComment()} >Save Comment and Date</Button>}

                {this.state.galleryModel.length === 0 &&
                    <p style={{ marginTop: "10px", textAlign: "center", color: "red" }}> No Documents Available for this Township.</p>}

                {this.state.galleryModel.length > 0 &&
                    <p style={txtStyle}>Document {this.state.selectedIndex + 1}/{this.state.galleryModel.length}</p>}

                {this.state.galleryModel.length > 0 &&
                    <Button disabled={this.state.prevBtndisable} onClick={() => this.previous()}>Previous</Button>}

                {this.state.galleryModel.length > 0 &&
                    <Button disabled={this.state.nextBtndisable} onClick={() => this.next()} >Next</Button>}

                {this.state.galleryModel.length > 0 &&
                    <Button color="red" disabled={this.props.disabled} onClick={() => this.deleteDocument()} >Delete</Button>}
            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./src/layers/tabs/cons-planning/documentsgallery.js